function Attribution() {
   return (
      <footer className="attribution">
         <p>Developed by <a href="https://twitter.com/Hashimdev1" target="_blank" rel="noreferrer">Hashimdev</a></p>
      </footer>
   );
}

export default Attribution;
